import * as React from "react";

import { Utils } from "../../common/utils";

export class Oops extends React.Component<any, any> {
    componentDidMount () {
    }

    render () {
        return(
            <div className="page-content">
                <div className="oops-container">
                    <h2>Oops. Looks like you took a wrong turn...</h2>
                    <div className="wanderer"></div>
                    <div className="start-over">Starting over at the <a href={`${Utils.getLinkBase()}`}>home page</a> might be a good idea. </div>
                </div>
            </div>
        );
    }
}
